<template>
    <div class="l-rule-body" v-if="isShow">
        <div class="l-rule-background" @click="handleClose">
        </div>
        <div class="l-rule-content">
            <div class="l-rule-title">规则说明</div>
            <img class="l-rule-hide" src="./images/hide.png" @click="handleClose" />
            <div class="l-rule-main">
                <div class="l-rule-item">
                    <div class="item-title">一、武功阶段加分【蓝色图标】</div>
                    <div class="item-setion">
                        <div class="item-text">
                            <div class="headline">1.新秀阶段直播指导的加分标准</div>
                            <div class="content">
                                <div class="item-score wu">
                                    <div class="score-top">+1</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    问题回答正确，但表达上只能“Yes”或“No”或一个中心词;
                                </div>

                            </div>
                            <div class="content">
                                <div class="item-score wu">
                                    <div class="score-top">+2</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    问题回答正确、表达上可用一个词组或小短句;
                                </div>
                            </div>
                            <div class="content">
                                <div class="item-score wu">
                                    <div class="score-top">+3</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    问题回答准确、表达上可用完整的句子。
                                </div>

                            </div>
                        </div>
                        <div class="item-text">
                            <div class="headline">2.少侠阶段直播指导的加分标准</div>
                            <div class="content">
                                <div class="item-score wu">
                                    <div class="score-top">+1</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    问题回答正确，但表达上只用一个中心词或一个词组;
                                </div>

                            </div>
                            <div class="content">
                                <div class="item-score wu">
                                    <div class="score-top">+2</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    问题回答正确、可用完整的句子回答但表达不够准确;
                                </div>
                            </div>
                            <div class="content">
                                <div class="item-score wu">
                                    <div class="score-top">+3</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    问题回答准确、表达内容完整准确。
                                </div>

                            </div>
                        </div>
                        <div class="item-text">
                            <div class="headline">3.大侠阶段直播指导的加分标准</div>
                            <div class="content">
                                <div class="item-score wu">
                                    <div class="score-top">+1</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    问题回答正确，但表达内容少;
                                </div>

                            </div>
                            <div class="content">
                                <div class="item-score wu">
                                    <div class="score-top">+2</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    问题回答正确、表达内容较多，但不太地道;
                                </div>
                            </div>
                            <div class="content">
                                <div class="item-score wu">
                                    <div class="score-top">+3</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    问题回答准确、表达完整地道。
                                </div>

                            </div>
                        </div>
                        <div class="item-text">
                            <div class="headline">4.掌门阶段小场景“回答”评分标准</div>
                            <div class="content">
                                <div class="item-score wu">
                                    <div class="score-top">+1</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    答案比较简单，短语或关键词，不需要队长帮助；
                                </div>

                            </div>
                            <div class="content">
                                <div class="item-score wu">
                                    <div class="score-top">+2</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    答案长度在一两句话，表达比较流畅、有语气，不需要队长帮助；
                                </div>
                            </div>
                            <div class="content">
                                <div class="item-score wu">
                                    <div class="score-top">+3</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    答案长度在两句话以上，表达比较流畅、有语气，不需要队长帮助。
                                </div>

                            </div>
                        </div>
                        <div class="item-text">
                            <div class="headline">5.掌门13-14段章扩听提问的加分标准</div>
                            <div class="content">
                                <div class="item-score wu">
                                    <div class="score-top">+1</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    问题回答正确，但表达内容少;
                                </div>

                            </div>
                            <div class="content">
                                <div class="item-score wu">
                                    <div class="score-top">+2</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    问题回答正确、表达内容较多，但不太地道;
                                </div>
                            </div>
                            <div class="content">
                                <div class="item-score wu">
                                    <div class="score-top">+3</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    问题回答准确、表达完整地道。
                                </div>

                            </div>
                        </div>
                        <div class="item-text">
                            <div class="headline">6.掌门阶段“复述”的加分标准</div>
                            <div class="content">
                                <div class="item-score wu">
                                    <div class="score-top">+3</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    没有条理，表达啰唆，不流畅，需要帮助总结;
                                </div>

                            </div>
                            <div class="content">
                                <div class="item-score wu">
                                    <div class="score-top">+5</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    有一定的条理，能在规定时间内完成总结，但表达不够流畅;
                                </div>
                            </div>
                            <div class="content">
                                <div class="item-score wu">
                                    <div class="score-top">+6</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    条理清楚，有总结能力，能在规定的时间内完成，而且表达基本到位。
                                </div>

                            </div>
                        </div>
                        <div class="item-text">
                            <div class="headline">7.掌门整考备战的中文引导问题的加分标准</div>
                            <div class="content">
                                <div class="item-score wu">
                                    <div class="score-top">+1</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    问题回答正确，但表达内容少;
                                </div>

                            </div>
                            <div class="content">
                                <div class="item-score wu">
                                    <div class="score-top">+2</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    问题回答正确、表达内容较多，但个别不在点上;
                                </div>
                            </div>
                            <div class="content">
                                <div class="item-score wu">
                                    <div class="score-top">+3</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    问题回答准确、表达内容较多，都在点上。
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="l-rule-item">
                    <div class="item-title">二、文功阶段加分【绿色图标】</div>
                    <div class="item-setion">
                        <div class="item-text">
                            <div class="headline">1.书童/秀才/举人“回答”的加分标准</div>
                            <div class="content">
                                <div class="item-score wen">
                                    <div class="score-top">+1</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    答案简单，能说出中心词或短语；
                                </div>

                            </div>
                            <div class="content">
                                <div class="item-score wen">
                                    <div class="score-top">+2</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    答案在1～2句话，答案完整，比较流畅；
                                </div>
                            </div>
                            <div class="content">
                                <div class="item-score wen">
                                    <div class="score-top">+3</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    答案3句话以上，答案完整，比较流畅。
                                </div>

                            </div>
                        </div>
                        <div class="item-text">
                            <div class="headline">2.书童/秀才/举人/进士“个读”评分标准</div>
                            <div class="content">
                                <div class="item-score wen">
                                    <div class="score-top">+4</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    读词，没有语流断句，读不出故事意思，需要队长带着读；
                                </div>

                            </div>
                            <div class="content">
                                <div class="item-score wen">
                                    <div class="score-top">+5</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    有意识去断句，去读故事意思，但不够流畅，错误不超过4处；
                                </div>
                            </div>
                            <div class="content">
                                <div class="item-score wen">
                                    <div class="score-top">+6</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    断句意识较好，语音语调比较好听，读书比较流畅，错误不超过2处；
                                </div>

                            </div>
                            <div class="content">
                                <div class="item-score wen">
                                    <div class="score-top">+7</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    断句意识很好，语音语调好听，读书流畅，没有错误。
                                </div>

                            </div>
                        </div>
                        <div class="item-text">
                            <div class="headline">3.进士整考备战的中文引导问题的加分标准</div>
                            <div class="content">
                                <div class="item-score wen">
                                    <div class="score-top">+1</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    问题回答正确，但表达内容少;
                                </div>

                            </div>
                            <div class="content">
                                <div class="item-score wen">
                                    <div class="score-top">+2</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    问题回答正确、表达内容较多，但个别不在点上;
                                </div>
                            </div>
                            <div class="content">
                                <div class="item-score wen">
                                    <div class="score-top">+3</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    问题回答准确、表达内容较多，都在点上。
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="l-rule-item">
                    <div class="item-title">三、直播指导的减分标准【红色图标】</div>
                    <div class="item-setion">
                        <div class="item-text">
                            <div class="content">
                                <div class="item-score subtract">
                                    <div class="score-top">-3</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    中途离开直播；
                                </div>

                            </div>
                            <div class="content">
                                <div class="item-score subtract">
                                    <div class="score-top">-4</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    说汉语；
                                </div>
                            </div>
                            <div class="content">
                                <div class="item-score subtract">
                                    <div class="score-top">-8</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    直播中走神（玩玩具、吃东西）；
                                </div>

                            </div>
                            <div class="content">
                                <div class="item-score subtract">
                                    <div class="score-top">-10</div>
                                    <div class="score-bottom"></div>
                                </div>
                                <div>
                                    直播中睡觉。
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        isClose: {
            type: Boolean,
        },
    },
    watch: {
        isClose(newValue) {

            this.isShow = newValue
        }
    },
    data() {
        return {
            isShow: false
        }
    },
    methods: {
        handleClose() {
            this.isShow = false
            this.$emit("closeRule")
        }
    }
}
</script>
<style lang="stylus" scoped>
@import "./index.styl"
</style>